import { Answer } from "./answer";
export class AnswerByType {
    constructor(answer_by_type) {
        this.type   = answer_by_type.type;
        this.answer = answer_by_type.answer ? this.getAnswerContent(answer_by_type.answer) : [];
    }
    getAnswerContent(list) {
        let result = [];
        for(let i = 0; i < list.length; i++) {
            if(list[i].status != 0 && list[i].status != '0') {
                result.push(new Answer(list[i]));
            }
        }
        return result;
    }

    getActiveAnswer() {
        let result = [];
        for(let i = 0; i < this.answer.length; i++) {
            if(this.answer[i].show_status != 0) {
                result.push(this.answer[i]);
            }
        }
        return result;
    }

    getAnswer(show_status = 1) {
        let result = [];
        for(let i = 0; i < this.answer.length; i++) {
            if(this.answer[i].show_status == show_status) {
                result.push(this.answer[i]);
            }
        }
        return result;
    }

    addNewAnswer() {
        this.answer.push(new Answer({id: null, content: '', show_status: 3, system: 'rating', type: this.type, status: 1}));
    }

    removeAnswer(index) {
        this.answer.splice(index, 1);
    }
}